import { TransactionFailureReasonDto } from './dtos/transactions'
import { match, DEFAULT } from '../utils/pattern-match-util'

export const enum TransactionFailureReason {
  Unknown = 'Unknown',
  MissingPayoutMethod = 'MissingPayoutMethod',
  PayoutGatewayError = 'PayoutGatewayError',
}

export function parseTransactionFailureReason(
  dto: TransactionFailureReasonDto,
): TransactionFailureReason {
  return match(dto, {
    MISSING_PAYOUT_METHOD: () => TransactionFailureReason.MissingPayoutMethod,
    PAYOUT_GATEWAY_ERROR: () => TransactionFailureReason.PayoutGatewayError,
    [DEFAULT]: () => {
      console.warn('Unknown transaction failure reason', dto)
      return TransactionFailureReason.Unknown
    },
  })
}

export function serializeTransactionFailureReason(
  reason: TransactionFailureReason,
): TransactionFailureReasonDto {
  return match<TransactionFailureReason, TransactionFailureReasonDto>(reason, {
    [TransactionFailureReason.MissingPayoutMethod]: () =>
      'MISSING_PAYOUT_METHOD',
    [TransactionFailureReason.PayoutGatewayError]: () => 'PAYOUT_GATEWAY_ERROR',
    [TransactionFailureReason.Unknown]: () => {
      throw new Error(
        `Cannot serialize unknown transaction failure reason '${reason}'`,
      )
    },
  })
}
